<template>
  <el-dialog
    :title="isUpdate ? '修改参数' : '添加参数'"
    :visible="visible"
    width="560px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="96px">
      <el-form-item label="参数名称:" prop="title">
        <el-input v-model="form.title" maxlength="50" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="参数编码:" prop="code">
        <el-input v-model="form.code" maxlength="100" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="参数类型:" prop="type">
        <el-select v-model="form.type" clearable class="ele-fluid" placeholder="请选择">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="参数值:">
        <el-switch
          v-if="form.type === 'switch'"
          v-model="form.value"
          active-value="1"
          inactive-value="0"
          active-text="开启"
          inactive-text="关闭" />
        <el-input
          v-else-if="form.type === 'password'"
          v-model="form.value"
          type="password"
          show-password
          clearable
          placeholder="请输入" />
        <el-input
          v-else-if="form.type === 'number'"
          v-model="form.value"
          clearable
          placeholder="请输入" />
        <el-input
          v-else-if="form.type === 'textarea' || form.type === 'array'"
          v-model="form.value"
          type="textarea"
          :rows="3"
          placeholder="请输入" />
        <el-input
          v-else
          v-model="form.value"
          clearable
          placeholder="请输入" />
      </el-form-item>
      <el-form-item label="选项配置:">
        <el-input
          v-model="form.options"
          type="textarea"
          :rows="3"
          placeholder="开关/单选/多选/下拉时使用，每行一项：值:标签；开关建议两行，如 1:开启 与 0:关闭" />
      </el-form-item>
      <el-form-item label="排序号:" prop="sort">
        <el-input-number
          v-model="form.sort"
          :min="0"
          :max="9999"
          controls-position="right"
          class="ele-fluid ele-text-left" />
      </el-form-item>
      <el-form-item label="状态:" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio v-for="item in statusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input v-model="form.note" type="textarea" :rows="2" maxlength="200" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

const defaultForm = () => ({
  title: '',
  code: '',
  type: 'text',
  value: '',
  options: '',
  sort: 0,
  status: 1,
  note: ''
});

export default {
  name: 'ParamDataEdit',
  props: {
    visible: Boolean,
    data: Object,
    configId: Number
  },
  data() {
    return {
      form: defaultForm(),
      rules: {
        title: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        type: [{ required: true, message: '请选择', trigger: 'change' }],
        sort: [{ required: true, message: '请输入', trigger: 'blur' }],
        status: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      loading: false,
      isUpdate: false,
      statusOptions: [],
      typeOptions: []
    };
  },
  mounted() {
    loadDictOptions('enable_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
    loadDictOptions('param_field_type')
      .then((list) => { this.typeOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
    data() {
      if (this.visible) {
        this.initForm();
      }
    }
  },
  methods: {
    initForm() {
      if (this.data && Object.keys(this.data).length) {
        this.form = Object.assign(defaultForm(), this.data);
        this.isUpdate = true;
      } else {
        this.form = defaultForm();
        this.isUpdate = false;
      }
      if (this.form.type === 'switch') {
        const on = ['1', 'true', 'on', 'yes', '开启'].includes(String(this.form.value).toLowerCase());
        this.form.value = on ? '1' : '0';
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.$http.post('/configdata/edit', Object.assign({}, this.form, {
          config_id: this.configId
        })).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
